import { Close } from '@mui/icons-material';
import { Button, Grid, IconButton, Snackbar, SnackbarContent } from '@mui/material';
import React, { useState } from 'react';
import { useCookies } from 'react-cookie';

import appConfig from '../../config/app.config';
import theme from '../../utilities/theme';

export default function AppListingSnackbar() {
  const [cookies, setCookie] = useCookies(['ignore_app_listing']);

  const [open, setOpen] = useState(
    !cookies.ignore_app_listing &&
      ['iPhone', 'Android'].some(os => navigator.userAgent.includes(os)),
  );

  const onOpenApp = () => {
    if (navigator.userAgent.includes('iPhone')) {
      window.location.replace('https://apps.apple.com/us/app/procure-vendor-sourcing/id6470758573');
    } else if (navigator.userAgent.includes('Android')) {
      if (appConfig.isProductionEnvironment()) {
        window.location.replace('https://play.google.com/store/apps/details?id=com.procure');
      } else {
        window.location.replace('https://play.google.com/apps/internaltest/4701340897648248806');
      }
    }
  };

  const onIgnore = () => {
    setOpen(false);
    setCookie('ignore_app_listing', Date.now(), {
      path: '/',
      sameSite: 'strict',
      maxAge: 24 * 60 * 60 * 14,
    }); // Cookie expires after 14 days
  };

  return (
    <Snackbar
      open={open}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      sx={styles.snackbar}
    >
      <SnackbarContent
        sx={styles.snackbarContent}
        message={
          <Grid container spacing={1}>
            <Grid item alignContent={'center'}>
              <img src='/procure_favicon.svg' alt='ProCure Favicon' />
            </Grid>
            <Grid item alignContent={'center'} sx={styles.snackbarMessage}>
              Open in the ProCure app
            </Grid>
          </Grid>
        }
        action={
          <Grid container sx={styles.snackbarAction}>
            <Grid item alignContent={'center'}>
              <Button onClick={onOpenApp} sx={styles.button}>
                Open
              </Button>
            </Grid>
            <Grid item alignContent={'center'}>
              <IconButton onClick={onIgnore}>
                <Close sx={styles.closeIcon} />
              </IconButton>
            </Grid>
          </Grid>
        }
      />
    </Snackbar>
  );
}

const styles = {
  snackbar: {
    width: '100%',
    left: 0,
    right: 0,
    bottom: 0,
  },
  snackbarContent: {
    width: '100%',
    maxWidth: 600,
    backgroundColor: theme.palette.background.default,
  },
  snackbarMessage: {
    color: theme.palette.text.primary,
  },
  snackbarAction: {
    marginLeft: 0,
  },
  button: {
    color: theme.palette.common.white,
    backgroundColor: theme.palette.primary.main,
    minWidth: 49,
  },
  closeIcon: {
    color: theme.palette.secondary.dark,
  },
};
